import React, { useEffect, useMemo, useState } from 'react';
import { pathToRegexp } from 'path-to-regexp';
import { Redirect, Route, Switch } from 'react-router-dom';
import Header from '../components/Header';
import Toast from '../components/common/Toast';

import { mainRoutes } from '../routes';
import { ContentArea, LayoutContainer, Toolbar } from './style';
import { useDispatch, useSelector } from 'react-redux';
import SideMenu from '../components/SideMenu';
import { GET_NOTIFICATIONS } from '../actions/types';

const Layout = ({ history }) => {
  const  dispatch = useDispatch()
  const { isAuthenticated, isAdm } = useSelector(({ auth }) => ({
    isAuthenticated: auth?.isAuthenticated || false,
    isAdm: auth?.userData?.isAdm || false,
  }));
  const [openSideMenu, setOpenSideMenu] = useState(false);


  useEffect(() => {
    if (isAuthenticated && window?.location?.pathname?.match('/login')) return history.push('/home');
    if (!isAuthenticated) return history.push('/login');
    if (!isAdm && window?.location?.pathname?.match(/Admin/gi)) return history.push('/home');
  }, []);

  const switchRoutes = useMemo(
    () => (
      <Switch>
        {mainRoutes.map(({ path, component }, key) => {
          return <Route exact path={path} component={component} key={key} />;
        })}
        <Redirect from='*' to='/404' />
      </Switch>
    ),
    [mainRoutes],
  );

  useEffect(() => {
    dispatch({
      type: GET_NOTIFICATIONS,
      payload: null,
    });
  
  }, []);

  const { hideHeader } = mainRoutes.find((r) => pathToRegexp(r.path).exec(window.location.pathname)) || {};

  return (
    <>
      {hideHeader ? (
        <>
          {switchRoutes}
          <Toast />
        </>
      ) : (
        <>
          <LayoutContainer>
            <Header setOpenSideMenu={setOpenSideMenu} openSideMenu={openSideMenu} />
            <SideMenu onMouseEnter={() => setOpenSideMenu(true)} onMouseLeave={() => setOpenSideMenu(false)} open={openSideMenu} />
            <ContentArea>
              <Toolbar />
              {switchRoutes}
              <Toast />
            </ContentArea>
          </LayoutContainer>
        </>
      )}
    </>
  );
};

export default Layout;
